export default "__VITE_ASSET__CraLf6zW__"